import { Component, OnDestroy } from '@angular/core';
import { ReportService } from '../../services/report.service';
import { ReportResponse } from '../../models/report-response.model';
import { EventsService } from '../../../events/services/events.service';

@Component({
    selector: 'app-report-archive',
    templateUrl: './report-archive-list.component.html',
    styleUrls: ['../../scss/report-list-common.scss']
})

export class ReportArchiveComponent implements OnDestroy {
    archivedProjectList: ReportResponse[];
    archivedProjectCount: number;
    selectedProjectsList: ReportResponse[];
    selectedReportCount: number;
    completingAction = false;
    actionText: string;

    constructor(private reportService: ReportService, private eventsService: EventsService) {
        reportService.onReportSummaryUpdate.subscribe(
            (updatedList) => {
                this.archivedProjectList = updatedList.filter((reportResponse) => reportResponse.report.isDeleted);
                this.archivedProjectCount = this.archivedProjectList.length;
                this.selectedProjectsList = this.archivedProjectList.filter((r) => r.report.isSelected);
                this.selectedReportCount = this.selectedProjectsList.length;
                this.completingAction = false;
            },
            (error) => console.error(error)
        );
        this.reportService.getAllReportSummarys();
    }

    ngOnDestroy() {
        this.selectedProjectsList.filter(p => p.report.isSelected).forEach(p => p.report.isSelected = false);
    }

    get itemsSelected() {
        return this.selectedProjectsList.some( (i) => i.report.isSelected);
    }

    select(event: any, report: ReportResponse) {
        report.report.isSelected = event.target.checked;

        if (report.report.isSelected) {
            this.selectedProjectsList.push(report);
        }else {
            this.selectedProjectsList.splice(this.selectedProjectsList.indexOf(report), 1);
        }

        this.selectedReportCount = this.selectedProjectsList.length;
    }

    restoreReports(report: ReportResponse = null) {
        this.setSpinner(false, 'Restoring Reports');
        if (this.selectedReportCount === 0 && report === null) {
            this.setSpinner(true);
            return;
        }
        const reports = new Array<ReportResponse>();
        if (report !== null) {
            reports.push(report);
        }

        if (this.selectedReportCount > 0) {
            this.selectedProjectsList.forEach( (r) => reports.push(r) );
        }

        this.eventsService.recordReportRestoredEvent();

        this.reportService.restoreReports(Array.from(new Set(reports))).subscribe(
            (response) => {
                this.reportService.getAllReportSummarys();
            },
            (error) => {
                console.error(error);
                this.setSpinner(true);
            }
        );
    }

    deleteReports(report: ReportResponse = null) {
        this.setSpinner(false, 'Deleting Reports');
        if (this.selectedReportCount === 0 && report === null) {
            this.setSpinner(true);
            return;
        }
        const reports = new Array<ReportResponse>();
        if (report !== null) {
            reports.push(report);
        }

        if (this.selectedReportCount > 0) {
            this.selectedProjectsList.forEach( (r) => reports.push(r) );
        }

        this.eventsService.recordReportDeletedEvent();

        this.reportService.deleteReports(Array.from(new Set(reports)))
        .subscribe(
            (response) => {
                this.reportService.getAllReportSummarys();
            },
            (error) => {
                console.error(error);
                this.setSpinner(true);
            }
        );
    }

    setSpinner(completed: boolean, text: string = '') {
        this.completingAction = !completed;
        this.actionText = text;
    }
}



// WEBPACK FOOTER //
// ./src/app/report/components/archive-list/report-archive-list.component.ts